import { styled } from "styled-components";

export const Container = styled.div`
  cursor: pointer;
  &,
  div {
    display: flex;
    width: 100%;
  }
`;

export const TimerContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: flex-end;
  min-width: 78px;
  label {
    padding-bottom: 0;
  }
`;

export const AudioBarContainer = styled.div<{
  $backgroundColor: string;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-3"].value}rem
    ${({ theme }) => theme.spacing["spacing-3"].value}rem
    ${({ theme }) => theme.spacing["spacing-5"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-s"].value}rem;
  background: ${({ $backgroundColor }) => $backgroundColor};
  box-shadow: 1px 1px 20px 0px #010d16;
  backdrop-filter: blur(4px);
`;

export const BarHeading = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;

export const TextContainer = styled.div<{ $height: number }>`
  height: ${({ $height }) => $height + "px"};
  transition: all 0.3s ease-in-out;
  overflow: hidden;
`;
